module.exports = __webpack_public_path__ + "img/wx.43969f97.jpg";